import { useState } from 'react';
import { provide, useAsyncEffect } from '@hilma/tools';
import axios from 'axios';
import { FormSelect, Area, useTransformObject, Localize, FormProvider, FormInput, useForm, useAlert, useLanguage, useFormInputStyles } from '@hilma/netina2all';

import { stationRules } from '../constants';
import { Button } from '../components';
import { useI18n } from '../hooks';

// import LocationAutoCompleteDropdown from './LocationAutocompleteDropdown';
import MapAddressSearch from '../routes/Profile/StationManagement/DetailsComponents/MapAddressSearch';
import { InputLabel } from '@material-ui/core';

const initialValues = {
    name: '',
    phone: '',
    confirmPhone: '',
    email: '',
    area: '',
    inputOrMap: '',
    address: '',
    location: {
        lat: null,
        lng: null,
    },
};

const refs = { name: null, phone: null, email: null, address: null, location: { lat: null, lng: null } };

interface StationRegistrationFormProps {
    openPopup: Function;
}

const StationRegistrationForm: React.FC<StationRegistrationFormProps> = ({ openPopup }) => {
    const assoReg = useI18n(i18n => i18n.assoReg);
    const stationReg = useI18n(i18n => i18n.stationReg);
    const pd = useI18n(i18n => i18n.pd);
    const errText = useI18n(i18n => i18n.errText);
    const typeOrClick = useI18n(i18n => i18n.sm.address.typeOrClick);
    const language = useLanguage();
    const form = useForm();
    const formInputStyles = useFormInputStyles();
    const transformObject = useTransformObject();
    const [areas, setAreas] = useState<Localize<Area>[] | null>(null)

    const alert = useAlert();

    useAsyncEffect(async () => {

        try {

            const { data } = await axios.get<Localize<Area>[]>('/api/area');

            const translated = data && data.map(a => (transformObject(a)));

            setAreas(translated as unknown as Localize<Area>[]);

        } catch (err) {
            alert(errText.generalSystem);
        }

    }, [])

    const onSubmit = async () => {
        try {
            form.handleSubmit();

            if (!form.isValid || !Object.values(form.touched).length) return alert(errText.invalidInfo);

            const res = await axios.post('/api/station/register-station', { ...form.values, language /* address: form?.values?.address?.description */ });
            return openPopup();
        } catch (err: any) {
            const error = (() => {
                switch (err.status) {
                    case 422:
                        return errText.googleMapsStation.israelLoc;
                    case 404:
                        return errText.googleMapsStation.locationNotFound;
                    case 400:
                        if (err.data.message[0] === "phone must be a phone number") return errText.phone;
                        else if (err.data.message[0] === 'Please enter a phone number without any spaces or dashes') return errText.phoneWoOther;
                        else if (err.data.message[0] === "email must be an email") return errText.email;
                        else if (err.data.message[0] === "name must be longer than or equal to 2 characters" || err.data.message[0] === "name must be shorter than or equal to 45 characters") return errText.name;
                        else return errText.generalSystem;
                    case 409:
                        return errText.googleMapsStation.userExists4station;
                    default: return errText.generalSystem;
                }
            })();
            alert(error);
        }
    }

    return (
        <div>
            <form className='form' onSubmit={form.handleSubmit}>
                <FormInput id="name" description={stationReg.labels.fullName} />
                <FormInput id="email" type="email" dir="ltr" description={stationReg.labels.email} />
                <FormInput id="phone" dir="ltr" description={stationReg.labels.phone} />
                <FormInput id="confirmPhone" dir="ltr" description={pd.confirmPhone} />
                <FormSelect id='area' description={stationReg.labels.area} options={areas ? areas.map(x => ({ id: x.id, value: x.areaName })) : []} />
                {/* <LocationAutoCompleteDropdown /> */}
                <InputLabel htmlFor={'address'} className={formInputStyles.label}>{typeOrClick}:</InputLabel>
                <MapAddressSearch />
                <Button submit onClick={onSubmit}>{assoReg.sendBtn}</Button>
            </form>
        </div>
    );
}

export default provide(
    [FormProvider, { initialValues, refs, rules: stationRules }]
)(StationRegistrationForm);
